import { Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { keyframes } from '@emotion/react';

const THINKING_LABELS = ['Thinking', 'Considering', 'Reasoning', 'Reflecting'];
const LABEL_DURATION_SECONDS = 3;
const CYCLE_DURATION_SECONDS = THINKING_LABELS.length * LABEL_DURATION_SECONDS;

const wordTransition = keyframes`
  0%, 22% { opacity: 1; transform: translateY(0); }
  25% { opacity: 0; transform: translateY(-4px); }
  97% { opacity: 0; transform: translateY(4px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export const ThinkingIndicator = () => (
  <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1, mb: 2 }}>
    {/* Keep the live announcement stable while the decorative words cycle. */}
    <Box
      component="span"
      sx={{
        position: 'absolute',
        width: 1,
        height: 1,
        p: 0,
        m: -1,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      Thinking…
    </Box>
    <AutoAwesomeIcon
      aria-hidden="true"
      sx={{
        fontSize: 18,
        color: 'primary.main',
        animation: `${pulse} 1.5s ease-in-out infinite`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }}
    />
    <Box aria-hidden="true" sx={{ display: 'grid', overflow: 'hidden' }}>
      {THINKING_LABELS.map((label, index) => (
        <Typography
          key={label}
          component="span"
          variant="body2"
          sx={{
            gridArea: '1 / 1',
            color: 'text.secondary',
            whiteSpace: 'nowrap',
            animation: `${wordTransition} ${CYCLE_DURATION_SECONDS}s ease-in-out infinite`,
            // Stagger a running cycle so the first label is visible immediately.
            animationDelay: `${index * LABEL_DURATION_SECONDS - CYCLE_DURATION_SECONDS}s`,
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none',
              opacity: index === 0 ? 1 : 0,
              transform: 'none',
            },
          }}
        >
          {label}…
        </Typography>
      ))}
    </Box>
  </Box>
);
